module.exports = __webpack_public_path__ + "img/disaster_relief-hotspot-2.715d0968.png";